import React, {  useState } from "react";
import { getEnvData } from "../Services/LoginApi";
import { MenuItem, Select } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { getUserDetails } from "../Services/DashboardApi";
 
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Settings from '@mui/icons-material/Settings';
 
const Navbar: React.FC = () => {
  const [userDetail, setUserDetails] = useState<any>();
  const userDetails = localStorage.getItem("userDetails");
  let fullName = "";
  let environments: string[] = [];
  if (userDetails) {
    const parsedUser = JSON.parse(userDetails);
    fullName = `${parsedUser.first_name ?? ''} ${parsedUser.last_name ?? ''}`.trim();
    environments = Array.isArray(parsedUser.environments) ? parsedUser.environments : [];
  }
  const getInitialEnv = () => {
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      try {
        const parsed = JSON.parse(userDetails);
        return parsed.selected_environment;
      } catch (e) {
        console.error("Error parsing userDetails:", e);
      }
    }
  };
  const [selectedEnv, setSelectedEnv] = useState<string>(getInitialEnv);
 
  const handleEnvChange = async (event: any) => {
    const newEnv = event.target.value;
    setSelectedEnv(newEnv);
 
    try {
      const response = await getEnvData(newEnv);
      if (response.success === true) {
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken: any = jwtDecode(token);
          const userId = decodedToken.id;
          const data = await getUserDetails(userId);
          if (!data.error && data.userData) {
            const updatedUserDetails = {
              ...data.userData,
              selected_environment: newEnv,
            };
            localStorage.setItem(
              "userDetails",
              JSON.stringify(updatedUserDetails)
            );
            setUserDetails(data);
            setSelectedEnv(newEnv);
            window.location.reload();
          }
        }
      }
    } catch (error) {
      console.error("Failed to update environment:", error);
    }
  };
 
 
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event:any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
 
  return (
    <div className="header">
      <div className="header__content">
        <div className="header__right">
          <Select
            value={selectedEnv}
            onChange={handleEnvChange}
            sx={{ minWidth: 120, height: 32, fontSize: '14px' }}
          >
            {environments.map((env) => (
              <MenuItem sx={{fontSize: '14px'}} key={env} value={env}>
                {env.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
          {/* <div className="header__icon">
       
       <span><NotificationIcon/></span>
        </div> */}
          <div className="header__profile">
            {/* <span className="header__icon"><UserIcon/></span>
          <span className="header__name">{fullName}</span> */}
 
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar className="avtar" sx={{ width: 30, height: 30 }}>{fullName?.trim()?.charAt(0)?.toUpperCase()}</Avatar>
            </IconButton>
 
            <Menu
            className="menu-item"
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleClose}>
                <Avatar>{fullName?.trim()?.charAt(0)?.toUpperCase()}</Avatar> {fullName}
              </MenuItem>
           
              <Divider />
   
              <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Profile
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem> */}
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default Navbar;
 
 